import {HomePage} from './home/home';
import {HomeSetPage} from './homeset/homeset';
import {MyServicesPage} from './myservices/myservices';
import {NewsListPage} from './news/list/list';
import {NewsDetail} from './news/detail/detail';
import {SearchPage} from './search/search';


export const HOME_INDEX = [
  HomePage,
  HomeSetPage,
  MyServicesPage,
  NewsListPage,
  NewsDetail,
  SearchPage,
];



// WEBPACK FOOTER //
// ./src/pages/home/index.ts